import { lazy, Suspense } from 'react';
import { Outlet, createRoute, SearchSchemaInput } from '@tanstack/react-router';

import DashboardLayout from 'src/layouts/dashboard';

import AppAuthGuard from 'src/components/auth/app-auth-guard';
import { SplashScreen, LoadingScreen } from 'src/components/loading-screen';

import { FavouritesSearchParamsSchema } from 'src/sections/favourites/view';

import { rootRoute } from './root';

const Favourites = lazy(() => import('src/sections/favourites/view'));

// Favourites routes
const favouritesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'favourites',
  component: () => (
    <AppAuthGuard splashScreen={<SplashScreen />}>
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    </AppAuthGuard>
  ),
});

const favouritesIndexRoute = createRoute({
  getParentRoute: () => favouritesRoute,
  path: '/',
  component: Favourites,
  validateSearch: (search: unknown & SearchSchemaInput) =>
    FavouritesSearchParamsSchema.validateSync(search),
});

export const favouritesRouteTree = favouritesRoute.addChildren([favouritesIndexRoute]);
